export default __webpack_public_path__ + "static/GilroySemiBold-393ac7fa7e96b8f9631a46d33d1151ae.woff";